import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  TemplateRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'suka-date-picker-input',
  template: `
    <div class="date-picker-input"
      [ngClass]="{
        'date-picker--single' : type === 'single',
        'date-picker--range' : type === 'range',
        'skeleton' : skeleton
      }">
      <div class="date-picker-input-container">
        <label *ngIf="label" [for]="id" class="label">
          <ng-container *ngIf="!isTemplate(label)">{{label}}</ng-container>
          <ng-template *ngIf="isTemplate(label)" [ngTemplateOutlet]="label"></ng-template>
        </label>
        <div class="date-picker-input__wrapper">
          <input
            *ngIf="!skeleton"
            autocomplete="off"
            type="text"
            class="date-picker__input"
            [value]="value"
            [pattern]="pattern"
            [placeholder]="placeholder"
            [id]= "id"
            [disabled]="disabled"
            (change)="onChange($event)"/>
            <suka-icon
              icon="calendar"
              class="date-picker__icon"
              *ngIf="!timePicker"
            >
            </suka-icon>
            <suka-icon
              icon="clock"
              class="date-picker__icon"
              *ngIf="timePicker"
            >
            </suka-icon>
        </div>
        <div *ngIf="invalid" class="form-requirement">
          <ng-container *ngIf="!isTemplate(invalidText)">{{invalidText}}</ng-container>
          <ng-template *ngIf="isTemplate(invalidText)" [ngTemplateOutlet]="invalidText"></ng-template>
        </div>
      </div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatePickerInput,
      multi: true
    }
  ]
})
export class DatePickerInput {
  private static datePickerCount = 0;

  /**
   * Select a calendar type for the `model`.
   */
  @Input() type: 'simple' | 'single' | 'range' = 'simple';

  /**
   * Sets the id for the `DatePickerInput`.
   */
  @Input() id = `datepicker-${DatePickerInput.datePickerCount++}`;

  /**
   *  Set to `true` to display a calendar icon
   */
  @Input() hasIcon = false;

  /**
   * label content.
   */
  @Input() label: string | TemplateRef<any>;

  /**
   * Sets the input's placeholder.
   */
  @Input() placeholder = 'dd/mm/yyyy';

  /**
   * Sets the pattern to follow.
   */
  @Input() pattern = '^\\d{1,2}/\\d{1,2}/\\d{4}$';

  /**
   * Emits event notifying other classes of a value change.
   */
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  /**
   * Set to `true` to disable the input
   */
  @Input() disabled = false;

  /**
   * Set to `true` to display invalid state.
   */
  @Input() invalid = false;

  /**
   * Feedback message to display when `DatepickerInput` is invalid.
   */
  @Input() invalidText: string | TemplateRef<any>;

  /**
   * Sets a time picker icon for input
   */
  @Input() timePicker = false;

  /**
   * Skeleton state.
   */
  @Input() skeleton = false;

  /**
   * Sets the `DatepickerInput` value.
   */
  @Input() value = '';

  constructor(protected elementRef: ElementRef) { }

  /**
   * Sets the value, marks the input as touched and emits a value change event.
   */
  onChange(event) {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
    this.propagateChange(this.value);
    this.onTouched();
  }

  public writeValue(value: any) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onTouched: () => any = () => { };

  propagateChange = (_: any) => { };

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }
}
